// PAQUETES
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
// estilos
import '../../../estilos/reserva.css';
import '../../../estilos/usuario.css'; // .contenedorPagoDestacado (resalta el botón de Wompi)
// funciones
import { slugify, normalizarResumen } from "../../../funcionesDatos/Textos";
import { formatearMoneda } from "../../../funcionesDatos/Moneda";
import { obtenerIdInvitado, leerIdInvitado, limpiarIdInvitado } from "../../../funcionesDatos/idInvitado";
// componentes
import CabeceraPagos from '../../../componentesEspeciales/pagos/cabeceraPagos';
import ZonaCargando from '../../alertas/zonaCargando';
import CardServicio from '../../../componentesEspeciales/cardServicio';
import PaqueteSeleccionado from "../../../componentesEspeciales/paqueteSeleccionado";
import WidgetWompi from "../../../componentesEspeciales/pagos/widgetWompi";
import ResumenReserva from "../../../componentesEspeciales/reserva/resumenReserva";
import Llamanos from "../../../componentesEspeciales/llamanos";


function Pago(){
  const location = useLocation();
  const navigate = useNavigate();

  const { usuario, cargandoUsuario, ahoraServidor } = useOutletContext() || {};
  const [cargando, setCargando]      = useState(false);
  const cargandoFinal                = Boolean(cargandoUsuario) || Boolean(cargando);
  
  const [idServicio, setidServicio]   = useState(null); 
  const [servicio, setServicio]       = useState(null);
  const [tipoPaquete, setTipoPaquete] = useState(null); // Básico, Premium, Avanzado
  const [zonaHoraria, setZonaHoraria] = useState("America/Bogota"); // inicializamos con bogota
  const [reserva, setReserva]         = useState(null);
  // --- Reseñas / vendedor (vienen junto con /buscar-servicio) ---
  const [valVendedor, setValVendedor]   = useState([]);
  const [vendedor, setVendedor]         = useState(null);
  const [resuServicio, setResuServicio] = useState({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
  const [resuVendedor, setResuVendedor] = useState({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });

  // --- UI Reserva (boceto) ---
  const [paso, setPaso]                           = useState(2); // 1 seleccionar fecha, 2 pagar
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null); // Date
  const [horaSeleccionada, setHoraSeleccionada]   = useState("");
  const [horarioExactoSeleccionado, setHorarioExactoSeleccionado] = useState(null);
  const [franjaSeleccionada, setFranjaSeleccionada] = useState("NA"); // manana|tarde|noche|NA

  // --- Countdown checkout (30 min) ---
  const [expiraEn, setExpiraEn] = useState(null); // ISO string or Date
  const [segundosRestantes, setSegundosRestantes] = useState(null); // number

  // Trigger para recargar datos (útil cuando cancelamos desde CabeceraPagos)
  const [refetchReserva, setRefetchReserva] = useState(0);

  // wompi
  const [wompiConfig, setWompiConfig] = useState(null);

  const ultimoIdServicioCargadoRef = useRef(null);
  const ahoraBaseServidorRef = useRef(null);
  const ahoraBaseClienteRef = useRef(null);

  useEffect(() => {
    if (!ahoraServidor) {
      ahoraBaseServidorRef.current = null;
      ahoraBaseClienteRef.current = null;
      return;
    }

    const fechaServidor = new Date(ahoraServidor);
    const fechaValida = Number.isNaN(fechaServidor.getTime()) ? null : fechaServidor;

    if (!fechaValida) {
      ahoraBaseServidorRef.current = null;
      ahoraBaseClienteRef.current = null;
      return;
    }

    ahoraBaseServidorRef.current = fechaValida.getTime();
    ahoraBaseClienteRef.current = Date.now();
  }, [ahoraServidor]);
    
 




  useEffect(() => {
  (async () => {
  try {
    setCargando(true);
    // 1) Esperar a que Direccionamiento termine de verificar token
    if (cargandoUsuario) return;

    // 2) Si el usuario ya inició sesión y quedó un hold de invitado pendiente (llegó a /pago sin
    // sesión, eligió fecha/dirección y recién ahora se loguea), lo reclamamos primero.
    if (usuario) {
      const idInvitadoPendiente = leerIdInvitado();
      if (idInvitadoPendiente) {
        try {
          await axios.post("/reclamar-reserva", {
            params: { idInvitado: idInvitadoPendiente, idComprador: usuario.idUsuario }
          });
        } catch (errReclamo) {
          // 404 = no había hold de invitado activo (ya se reclamó antes o expiró) — no es un error real
          console.log("No se pudo reclamar el hold de invitado:", errReclamo?.response?.data || errReclamo);
        } finally {
          limpiarIdInvitado();
        }
      }
    }

    // buscar el hold activo: del comprador logueado, o del invitado si no hay sesión todavía
    const resReserva = await axios.post("/obtener-reserva", {
      params: usuario ? { idComprador: usuario.idUsuario } : { idInvitado: obtenerIdInvitado() }
    });

    // si NO existe una reserva activa, limpiamos estados
    if (!resReserva?.data?.existe) {
      setExpiraEn(null);
      setSegundosRestantes(null);
      setidServicio(null);
      setTipoPaquete(null);
      setServicio(null);
      setValVendedor([]);
      setVendedor(null);
      setResuServicio({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
      setResuVendedor({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
      // reset UI selección
      setPaso(1);
      setFechaSeleccionada(null);
      setHorarioExactoSeleccionado(null);
      setFranjaSeleccionada("NA");
      setHoraSeleccionada("");
      ultimoIdServicioCargadoRef.current = null;
      // wompi
      setWompiConfig(null);

      return;
    }

    // si si existe una reserva
    if (resReserva.data.existe) {
      //console.log("reserva: ", resReserva.data.reserva);
      setReserva(resReserva.data.reserva);
      // buscamos el servicio
      let idDeServicio = resReserva.data.idServicio;
      setidServicio(idDeServicio);
      setTipoPaquete(resReserva.data.reserva.tipoPaquete); // guardamso el tipo de paquete
      setExpiraEn(resReserva?.data?.reserva?.expiraEn || null);

      const reservaActiva = resReserva?.data?.reserva || null;

      // Evitar re-cargar el mismo servicio varias veces
      if (ultimoIdServicioCargadoRef.current && String(ultimoIdServicioCargadoRef.current) === String(idDeServicio)) {
        return;
      }
      ultimoIdServicioCargadoRef.current = idDeServicio;

      const resServicio = await axios.post("/buscar-servicio", { params: { usuario: "NA", idServicio: idDeServicio } });
      const data = resServicio?.data || {};
      const srv = data?.servicio || null;

      setServicio(srv);
      // reseñas / vendedor
      setValVendedor(Array.isArray(data?.valoracionesVendedor) ? data.valoracionesVendedor : []);
      setVendedor(data?.usuarioVendedor || null);
      // ✅ Resumen del servicio: preferimos el nuevo formato: servicio.resumenReseñas
      setResuServicio(normalizarResumen({ resumenServicio: data?.resumenServicio, resumenReseñas: srv?.resumenReseñas }));
      // Resumen vendedor (por ahora viene en formato viejo desde backend)
      setResuVendedor(normalizarResumen({ resumenServicio: data?.resumenVendedor }));
      // obtener zona horaria
      setZonaHoraria(srv.zonaHoraria);

      // --- Hidratar selección de calendario/hora desde la reserva ---
      if (reservaActiva) {
        // fecha (guardada en backend como Date)
        if (reservaActiva?.fecha) {
          const f = new Date(reservaActiva.fecha);
          if (!Number.isNaN(f.getTime())) {
            // usamos mediodía UTC para evitar problemas de DST al renderizar
            setFechaSeleccionada(new Date(Date.UTC(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate(), 12, 0, 0)));
          }
        }

        // Si el paquete es por horas:
        const modo = reservaActiva?.modoAgenda || 'exacta';

        if (modo === 'exacta') {
          const h = (reservaActiva?.horaConfirmada && reservaActiva.horaConfirmada !== 'NA')
            ? reservaActiva.horaConfirmada
            : null;
          if (h) {
            setHorarioExactoSeleccionado(String(h));
          }
          setFranjaSeleccionada('NA');
          setHoraSeleccionada('');
        } else if (modo === 'flexible') {
          const fr = (reservaActiva?.franja && reservaActiva.franja !== 'NA') ? reservaActiva.franja : 'NA';
          const hs = (reservaActiva?.horaSolicitada && reservaActiva.horaSolicitada !== 'NA') ? reservaActiva.horaSolicitada : '';
          setFranjaSeleccionada(fr);
          setHoraSeleccionada(String(hs || ''));
          setHorarioExactoSeleccionado(null);
        }
      }

      // Obtener configuración de Wompi - paso 3: firma de identidad.
      // Sin sesión todavía no se puede pagar, así que ni intentamos pedirla (se pide apenas
      // el usuario inicia sesión y este efecto se vuelve a ejecutar).
      if (usuario) {
        try {
          const resWompi = await axios.post('/wompi/checkout-data', { idReserva: resReserva.data.reserva._id });
          const cfg      = resWompi?.data || null;
          //console.log("config wompi: ", cfg);
          //amountInCents : 6014600 currency : "COP" entorno : "LOCAL" integritySignature : "f444c7f1fc65da30ac4963a43fcc3d3634fff5f0579b9c9e58136c3c4c67351d" publicKey : "pub_test_N0LHla4wG65dSUUGCz8voPfHjCyNcNsw" reference : "RESERVA_69b64c3829195b5a9eee1fe4" urlEntorno : "http://localhost:3001"

          if (!cfg?.publicKey || !cfg?.amountInCents || !cfg?.reference) { throw new Error('No se recibieron datos completos para Wompi.'); }

          // guardamos la configuración
          setWompiConfig({
            ...cfg,
            customerEmail: usuario?.email || cfg?.customerEmail || "",
          });
        }
        catch (e) {
          console.error("Error cargando Wompi:", e);
          setWompiConfig({ errorInterno: e?.message || "No se pudo cargar Wompi.", });
        }
      } else {
        setWompiConfig(null);
      }
    }
  } 
  catch (err) {
    console.log("Error en reserva:", err);
    Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error cargando la reserva." });
  }
  finally { setCargando(false); }
  })();
  }, [cargandoUsuario, usuario, navigate, refetchReserva]);
   
   
  // CONTADOR EXPIRA EN
  useEffect(() => {
    if (!expiraEn) {
      setSegundosRestantes(null);
      return;
    }

    const exp = new Date(expiraEn).getTime(); // convierte expiraEn a timestamp.
    if (!Number.isFinite(exp)) {
      setSegundosRestantes(null);
      return;
    }

    // Importante: el contador debe usar la misma hora centralizada del backend.
    // En LOCAL/DESARROLLO, si cambiamos la fecha de pruebas en /obtener-ahora,
    // no podemos arrancar el contador con Date.now() del navegador porque queda desalineado.
    if (!ahoraServidor || !ahoraBaseServidorRef.current || !ahoraBaseClienteRef.current) {
      setSegundosRestantes(null);
      return;
    }

    const cuantoFalta = () => {
      // Base backend: fecha devuelta por /obtener-ahora.
      // Base cliente: instante real del navegador cuando recibimos esa fecha.
      // Así el contador avanza segundo a segundo, pero siempre alineado con obtenerAhora().
      const baseServidor = ahoraBaseServidorRef.current;
      const baseCliente = ahoraBaseClienteRef.current;
      const now = baseServidor + (Date.now() - baseCliente);
      const diffMs = exp - now;
      const s = Math.max(0, Math.floor(diffMs / 1000));
      setSegundosRestantes(s);
    };

    cuantoFalta();

    const id = setInterval(cuantoFalta, 1000);
    return () => clearInterval(id);
  }, [expiraEn, ahoraServidor]);

  

  
  
    





  return (
  <div className="container py-3">
    { cargandoFinal ? <ZonaCargando />
    :<div className="container py-4">
        
      <div className="mb-3">
        <h1 className="h3 mb-1">Pago</h1>
        <p className="text-body-secondary mb-0" style={{ fontSize: 13 }}> Aquí puedes gestionar tu reserva y seleccionar la fecha y hora antes de continuar al pago. </p>
      </div>

      {/* Cabecera pagos (timeline + contador) */}
      <CabeceraPagos
        paso={paso}
        segundosRestantes={segundosRestantes}
        duracionSegundos={10 * 60}
        idComprador={usuario?.idUsuario}
        onCancelSuccess={() => setRefetchReserva((x) => x + 1)}
      />

        

      {/* 2 columnas */}
      <div className="row g-3 mt-3">
        <div className="col-12 col-lg-7">
          {/* RESERVA */}
          {reserva && servicio ? (
            <ResumenReserva reserva={reserva} servicio={servicio} />
          ) : null}

          {/* LLÁMANOS: acompañamiento/confianza justo antes de pagar */}
          <div className="mt-3">
            <Llamanos />
          </div>
        </div>



        {/* RESUMEN Y PAGO */}
        <div className="col-12 col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="h5 fw-bold mb-3">Resumen de compra</h2>
              <div className="text-body-secondary" style={{ fontSize: 14 }}> Completa el pago sin salir de esta página. </div>

              {!reserva ? 
              <div className="text-body-secondary mt-3" style={{ fontSize: 13 }}>
                Debes tener una reserva activa para ver el formulario de pago.
              </div>
              : <div className="mt-3">

                {/* TOTAL A PAGAR */}
                <div className="d-flex align-items-center justify-content-between rounded-3" style={{ padding: '12px 14px', background: 'rgba(var(--azul-bootstrap-cta-rgb), 0.08)', border: '1px solid rgba(var(--azul-bootstrap-cta-rgb), 0.18)', }} >
                  {/* FILA 1 TEXTOS */}
                  <div>
                    <div className="fw-semibold">Total a pagar</div>
                    <div className="text-body-secondary" style={{ fontSize: 12 }}>
                      Incluye costo de servicio
                    </div>
                  </div>
                  {/* FILA 2 BANDERA Y PRECIO */}
                  <div className="fw-bold d-flex align-items-center justify-content-end gap-2" style={{ fontSize: 18 }}>
                    {(reserva?.cobro?.moneda ) === 'COP' ? 
                    <span aria-label="Colombia" title="Colombia" style={{ fontSize: 16 }}>🇨🇴</span>
                    : null}
                    <span> {formatearMoneda( reserva?.cobro?.montoTotal )} </span>
                  </div>
                </div>

                {/* BANNER DESTACADO: descuento primera compra */}
                {Number(reserva?.cobro?.descuentoPrimeraCompra || 0) > 0 ? (
                  <div
                    className="d-flex align-items-center gap-2 rounded-3 mt-2"
                    style={{ padding: '10px 14px', background: 'var(--verde-esmeralda)', color: 'white' }}
                  >
                    <i className="bi bi-gift-fill" style={{ fontSize: 18 }} />
                    <div>
                      <div className="fw-bold" style={{ fontSize: 13 }}>¡Descuento de primera compra aplicado!</div>
                      <div style={{ fontSize: 12, opacity: 0.9 }}>
                        Ahorras {formatearMoneda(reserva?.cobro?.descuentoPrimeraCompraMostrado, reserva?.cobro?.moneda)} ({Math.round((reserva?.cobro?.descuentoPrimeraCompraPct || 0) * 100)}%) por ser tu primera reserva
                        {!usuario ? ' — se confirma al iniciar sesión' : ''}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* DESGLOCE COMPLETO */}
                <div className="mt-2 border rounded-3 p-3" style={{ background: 'rgba(var(--negro-rgb), 0.02)' }}>
                  <div className="fw-semibold mb-2" style={{ fontSize: 12 }}>Desglose</div>

                  <div className="d-flex justify-content-between" >
                    <span className="text-body-secondary textosDesgloce">Subtotal</span>
                    <span className="textosDesgloce">{formatearMoneda(reserva?.cobro?.precioBaseProveedor , reserva?.cobro?.moneda )}</span>
                  </div>
                  <div className="d-flex justify-content-between" >
                    <span className="text-body-secondary textosDesgloce">Incremento de urgencia {reserva.cobro.porcentajeUrgencia + "%"} </span>
                    <span className="textosDesgloce">{formatearMoneda(reserva?.cobro?.montoUrgencia , reserva?.cobro?.moneda )}</span>
                  </div>

                  <div className="d-flex justify-content-between" >
                    <span className="text-body-secondary textosDesgloce">Costo de servicio</span>
                    <span className="textosDesgloce">
                      {formatearMoneda(
                        Number(reserva?.cobro?.descuentoPrimeraCompra || 0) > 0
                          ? reserva?.cobro?.costoServicioSinDescuento
                          : reserva?.cobro?.costoServicio,
                        reserva?.cobro?.moneda
                      )}
                    </span>
                  </div>

                  {Number(reserva?.cobro?.descuentoPrimeraCompra || 0) > 0 ? (
                    <div className="d-flex justify-content-between" >
                      <span className="fw-bold textosDesgloce" style={{ color: 'var(--verde-esmeralda)' }}>
                        <i className="bi bi-gift-fill me-1" />Descuento primera compra ({Math.round((reserva?.cobro?.descuentoPrimeraCompraPct || 0) * 100)}%)
                      </span>
                      <span className="fw-bold textosDesgloce" style={{ color: 'var(--verde-esmeralda)' }}>-{formatearMoneda(reserva?.cobro?.descuentoPrimeraCompraMostrado, reserva?.cobro?.moneda)}</span>
                    </div>
                  ) : null}

                  <hr className="my-2" />

                  <div className="d-flex justify-content-between">
                    <span className="fw-semibold textosDesgloce">Total</span>
                    <span className="fw-bold textosDesgloce">{formatearMoneda(reserva.cobro.montoTotal, reserva.cobro.moneda)}</span>
                  </div>
                </div>


                {/* contenedor wompi (resaltado: el botón real lo renderiza el script de Wompi) */}
                <div className="contenedorPagoDestacado">
                  {usuario ? (
                    <WidgetWompi
                      className="w-100 wompi-boton"
                      wompiConfig={wompiConfig && !wompiConfig?.errorInterno ? wompiConfig : null}
                      textoCargando="Cargando checkout..."
                      textoError={wompiConfig?.errorInterno || "No fue posible cargar Wompi. Intenta nuevamente."}
                      mostrarEstado={true}
                    />
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary w-100 wompi-boton"
                      onClick={() => navigate("/iniciar-sesion", { state: { returnTo: "/pago", returnState: {} } })}
                    >
                      Inicia sesión para pagar
                    </button>
                  )}
                </div>

                {/* MÉTODOS DE PAGO ACEPTADOS */}
                <img
                  src="/imagenes/pagoswompi.png"
                  alt="Pagos seguros con Visa, Mastercard, American Express, DaviPlata, Nequi y PSE"
                  className="d-block mx-auto mt-3"
                  style={{ maxWidth: 340, width: "100%", height: "auto" }}
                />

                {reserva ? (
                  <div className="mt-3 alert alert-info mb-0 rounded-4" style={{ fontSize: 13 }}>
                    <div className="fw-semibold mb-1">Importante</div>
                    No desembolsaremos tu pago al prestador del servicio hasta que finalice el tiempo del servicio y tú confirmes que fue realizado correctamente.
                  </div>
                ) : null}

                <div className="text-body-secondary mt-2" style={{ fontSize: 12 }}>
                  Al pagar, te notificaremos el estado automáticamente.
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  )
}


export default Pago;